import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

export const ButtonLightCSS = css`
  display: inline-block;

  & > a,
  & > button {
    background-color: ${({ theme }) => theme.color.light};
    color: ${(props) => props.theme.color.dark};
    padding: 15px;
    width: 100%;
    height: 100%;
    display: block;
    text-align: center;
    border-radius: 62px;
    transition: all 0.3s ease;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-family: ${({ theme }) => theme.font.family.secondary};

    @media (min-width: 1200px) {
      min-width: 160px;
    }

    &:hover {
      background-color: ${({ theme }) => theme.color.primaryDark};
      color: ${({ theme }) => theme.color.light};
    }
  }
`

const StyledButton = styled.span`
  ${ButtonLightCSS}
`

interface ButtonLightProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  target?: string
  children: any
  className?: string
}

const ButtonLight: React.FC<ButtonLightProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  target,
  children,
  className = '',
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonLight
